
  import { Vue, Component, Prop } from "vue-property-decorator";
  import SkillLabel from "@/components/skills/SkillLabel.vue";

  @Component({
    components: {
      SkillLabel,
    },
  })
  export default class SoftSkillMultiselectItem extends Vue {
    @Prop({ type: String, required: true }) readonly softSkillName!: string;
    @Prop({ type: String, required: true }) readonly labelText!: string;
  }
